import * as React from 'react';
import { Form, Popup, Segment } from 'semantic-ui-react';

import CorreoElectronico from './componentes/CorreoElectronico';
import ListaCorreos from './componentes/ListaCorreos';

export interface Datos {
    principal: string;
    otros: string[];
}

export const inicial: Datos = {
    principal: '',
    otros: [],
};

interface Props {
    requeridos: boolean;
    correos: Datos;
    onChange(correos: Datos): void;
}

class CorreosElectronicos extends React.PureComponent<Props> {
    public render() {
        const { requeridos, correos, onChange } = this.props;

        return (
            <Segment>
                <CorreoElectronico
                    correo={correos.principal}
                    onChangeCorreo={correo => {
                        onChange({ ...correos, principal: correo });
                    }}
                    width='6'
                    requerido={requeridos}
                />

                <ListaCorreos
                    requerido={requeridos}
                    array={correos.otros}
                    onChange={otros => {
                        onChange({ ...correos, otros });
                    }}
                />

                <Popup
                    trigger={
                        <Form.Button
                            type='button'
                            circular
                            compact
                            icon='plus'
                            color='green'
                            size='small'
                            onClick={() => {
                                const otros = [...correos.otros, ''];
                                onChange({ ...correos, otros });
                            }}
                        />
                    }
                    content='Agregar otro correo.'
                    position='right center'
                />
            </Segment>
        );
    }
}

export default CorreosElectronicos;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/CorreosElectronicos/index.tsx